import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { stateOptionsSample } from 'src/app/constants/service.constants';
import { RFP } from 'src/app/models/common';
import { Subject } from 'rxjs';
import { UserInstructionModalComponent } from '../user-instruction-modal/user-instruction-modal.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rfp-grants',
  templateUrl: './rfp-grants.component.html',
  styleUrls: ['./rfp-grants.component.scss']
})
export class RfpGrantsComponent implements OnInit {
  @Input() public Content: any;
  id: number;
  data: any;
  rtype: any;
  rowData;
  rfplist: RFP[] = [];
  selected: string[];
  constructor(
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    private router: Router,
    private summaryService: AdministrationSummaryService
  ) { }

  ngOnInit() {
    this.selected = [];
    if (this.data != null)
      this.rtype = this.data.rtype;
    this.getRfpSummary();
  }

  onChange(name: string, isChecked: boolean) {
    if (isChecked) {
      this.selected.push(name);
    } else {
      const index = this.selected.findIndex(x => x === name);
      this.selected.splice(index, 1);
    }
  }

  openExt() {
    //this.modalRef.hide();
    //this.modalService.show(UserInstructionModalComponent, {
    //  backdrop: false,
    //  keyboard: false,
    //  ignoreBackdropClick: true,
    //  class:'modal-vlg modal-full-height modal-right',
    //  animated: true
    //});


    //if (this.selected.length <= 0) {
    //  this.modalService.show(MessageBoxComponent, { data: { heading: 'Select', content: { heading: '', description: 'Please select atleast one RFP.' } } });
    //  return;
    //}

    if (this.selected.length > 1) {
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Select', content: { heading: '', description: 'Please select Only one RFP.' } } });
      return;
    }

    this.modalRef.dismiss();
   const modelRf= this.modalService.open(UserInstructionModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modelRf.componentInstance.Content={
      heading: 'Add',
      content: null,
      id: this.Content.id,
      rtype: this.Content.rtype
    }

        //this.router.navigateByUrl('/home/grants/applications/application-ext/:'+ this.id +'/general_information')
    // let url = location.href.split('/');
    // window.open(url[0] + '//' + url[2] + '/home/grants/applications/application-ext/:' + this.id + '/general_information');
  }
  getRfpSummary() {
    this.summaryService.getRfpSummary("0").subscribe(summary => {
      this.rfplist = summary;
    });
  }
}
